import { atom, selector } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

export const planEditorVisibleState = atom({
  key: 'planEditorVisibleState',
  default: selector({
    key: 'planEditorVisibleStateSelector',
    get: () => {
      return getCustomerSettings('panel.planEditor');
    }
  })
});